<script setup lang="ts">
import { AsyncDataKey } from '@/types/main'

const { data: simpleCategories } = useNuxtData(AsyncDataKey.SIMLE_CATEGORIES)
</script>

<template>
  <div class="menu-categories">
    <the-slider
      overlay="sm"
      :space-between="32"
      :slide-width="80"
      :ripple="false"
      is-different-width
    >
      <nuxt-link
        v-for="(category, index) in simpleCategories"
        :key="index"
        :prefetch="false"
        active-class="menu-categories__link--active"
        :to="category.path"
        class="menu-categories__link"
      >
        {{ category.name }}
      </nuxt-link>
    </the-slider>
  </div>
</template>

<style lang="scss" scoped>
.menu-categories {
  height: 100%;
  padding: 4px 24px;

  @include media('>=desktop') {
    max-width: 1200px;
    padding: 4px 0;
    margin: 0 auto;
  }

  &__link {
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    color: var(--ui-text-primary);

    &--active {
      color: var(--ui-primary);
    }
  }
}
</style>
